export default "__VITE_ASSET__FxSoVfLm__"